import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Delete from "components/videos/Delete";
import Information from "components/videos/Information";
import Edit from "components/videos/Edit";
const Toolbar = ({ video }) => {
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { className: "flex-grow", children: _jsx(Edit, { video: video }) }), _jsx(Information, { video: video }), _jsx(Delete, { video: video })] }) }));
};
export default Toolbar;
